import { render, staticRenderFns } from "./CustomerStateChip.vue?vue&type=template&id=c639026c&scoped=true"
import script from "./CustomerStateChip.vue?vue&type=script&lang=ts"
export * from "./CustomerStateChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c639026c",
  null
  
)

export default component.exports